export const CATTLE_CLASSES = [
  {
    id: 1,
    category: "Breeder",
    name: "Bulls (1+ years)",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 700,
      2: 700,
      3: 770,
      4: 770,
      5: 770,
      6: 700,
      7: 770,
      8: 770,
      9: 770
    }
  },
  {
    id: 2,
    category: "Breeder",
    name: "Steers (<1 year)",
    requiresMilk: true,
    weightByLocalityCode: {
      1: 500,
      2: 500,
      3: 550,
      4: 550,
      5: 550,
      6: 550,
      7: 550,
      8: 550,
      9: 550
    }
  },
  {
    id: 3,
    category: "Breeder",
    name: "Steers (1-2 years)",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 600,
      2: 600,
      3: 660,
      4: 660,
      5: 660,
      6: 660,
      7: 660,
      8: 660,
      9: 660
    }
  },
  {
    id: 4,
    category: "Breeder",
    name: "Steers (2+ years)",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 600,
      2: 600,
      3: 660,
      4: 660,
      5: 660,
      6: 660,
      7: 660,
      8: 660,
      9: 660
    }
  },
  {
    id: 5,
    category: "Breeder",
    name: "Cows (2+ years)",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 500,
      2: 500,
      3: 550,
      4: 550,
      5: 550,
      6: 550,
      7: 550,
      8: 550,
      9: 550
    }
  },
  {
    id: 6,
    category: "Breeder",
    name: "Heifers (<1 year)",
    requiresMilk: true,
    weightByLocalityCode: {
      1: 500,
      2: 500,
      3: 550,
      4: 550,
      5: 550,
      6: 550,
      7: 550,
      8: 550,
      9: 550
    }
  },
  {
    id: 7,
    category: "Breeder",
    name: "Heifers (1-2 years)",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 500,
      2: 500,
      3: 550,
      4: 550,
      5: 550,
      6: 550,
      7: 550,
      8: 550,
      9: 550
    }
  },
  {
    id: 8,
    category: "Breeder",
    name: "Heifers (2+ years - not calving)",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 500,
      2: 500,
      3: 550,
      4: 550,
      5: 550,
      6: 550,
      7: 550,
      8: 550,
      9: 550
    }
  },
  {
    id: 9,
    name: "Trade Steers (2+ years)",
    category: "Traded",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 600,
      2: 600,
      3: 660,
      4: 660,
      5: 660,
      6: 660,
      7: 660,
      8: 660,
      9: 660
    }
  },
  {
    id: 10,
    name: "Trade Steers (1-2 years)",
    category: "Traded",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 600,
      2: 600,
      3: 660,
      4: 660,
      5: 660,
      6: 660,
      7: 660,
      8: 660,
      9: 660
    }
  },
  {
    id: 11,
    name: "Trade Steers (<1 year)",
    category: "Traded",
    requiresMilk: false,
    weightByLocalityCode: {
      1: 500,
      2: 500,
      3: 550,
      4: 550,
      5: 550,
      6: 550,
      7: 550,
      8: 550,
      9: 550
    }
  }
]

export const SHEEP_CLASSES = [
  {
    id: 1,
    name: "Rams",
    category: "Breeder",
    requiresLambingForCPI: false,
    weightByLocalityCode: {
      1: 78,
      2: 78,
      3: 77,
      4: 70,
      5: 84,
      6: 70,
      7: 70,
      8: 70,
      9: 84
    }
  },
  {
    id: 2,
    name: "Wethers",
    category: "Breeder",
    requiresLambingForCPI: false,
    weightByLocalityCode: {
      1: 62,
      2: 62,
      3: 77,
      4: 70,
      5: 72,
      6: 72,
      7: 60,
      8: 60,
      9: 84
    }
  },
  {
    id: 3,
    name: "Maiden Breeding ewes",
    category: "Breeder",
    requiresLambingForCPI: false,
    weightByLocalityCode: {
      1: 57,
      2: 57,
      3: 55,
      4: 50,
      5: 60,
      6: 50,
      7: 50,
      8: 50,
      9: 60
    }
  },
  {
    id: 4,
    name: "Breeding ewes",
    category: "Breeder",
    requiresLambingForCPI: false,
    weightByLocalityCode: {
      1: 57,
      2: 57,
      3: 55,
      4: 50,
      5: 60,
      6: 50,
      7: 50,
      8: 50,
      9: 60
    }
  },
  {
    id: 5,
    name: "Other ewes",
    category: "Breeder",
    requiresLambingForCPI: false,
    weightByLocalityCode: {
      1: 57,
      2: 57,
      3: 55,
      4: 50,
      5: 60,
      6: 50,
      7: 50,
      8: 50,
      9: 60
    }
  },
  {
    id: 6,
    name: "Ewe lambs",
    requiresLambingForCPI: true,
    category: "Breeder",
    weightByLocalityCode: {
      1: 60,
      2: 60,
      3: 60,
      4: 55,
      5: 66,
      6: 55,
      7: 55,
      8: 55,
      9: 66
    }
  },
  {
    id: 7,
    name: "Wether Lambs",
    requiresLambingForCPI: true,
    category: "Breeder",
    weightByLocalityCode: {
      1: 60,
      2: 60,
      3: 60,
      4: 55,
      5: 66,
      6: 55,
      7: 55,
      8: 55,
      9: 66
    }
  },
  {
    id: 8,
    name: "Trade lambs and hoggets",
    requiresLambingForCPI: false,
    category: "Trade",
    weightByLocalityCode: {
      1: 60,
      2: 60,
      3: 60,
      4: 55,
      5: 66,
      6: 55,
      7: 55,
      8: 55,
      9: 66
    }
  },
  {
    id: 9,
    name: "Trade wethers",
    requiresLambingForCPI: false,
    category: "Trade",
    weightByLocalityCode: {
      1: 62,
      2: 62,
      3: 66,
      4: 60,
      5: 72,
      6: 60,
      7: 60,
      8: 60,
      9: 72
    }
  },
  {
    id: 10,
    name: "Trade ewes",
    requiresLambingForCPI: false,
    category: "Trade",
    weightByLocalityCode: {
      1: 57,
      2: 57,
      3: 55,
      4: 50,
      5: 60,
      6: 50,
      7: 50,
      8: 50,
      9: 60
    }
  }
]
